import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ReachOurTeam from "./sections/ReachOurTeam";
import ContactFooterInformation from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ReachOurTeam />
      <ContactFooterInformation />
    </div>;
}